import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles/existingLayouts.module.css';
import { MdDelete } from 'react-icons/md';
import { invalidateLayout } from '../../api/report/post';
import {
  setChecklistLayouts,
  setInventoryLayouts,
  setReportLayouts,
  setTrackerLayouts,
} from '../../Redux/slices/UIBuilderLayouts';
import {
  setChecklistTabItems,
  setInventoryTabItems,
  setReportsTabItems,
  setTrackerTabItems,
} from '../../Redux/slices/tabSlice';
import { HashLoader } from 'react-spinners';
const LayoutCard: React.FC<any> = ({
  isLoading,
  layoutId,
  reportName,
  reportDescription,
  deleteLayout,
}) => {
  const { sitePermissions } = useSelector((state: any) => state.user);
  return (
    <div className={styles.layoutCardWrapper}>
      {!isLoading ? (
        sitePermissions.deleteLayouts && (
          <MdDelete
            className={styles.deleteIcon}
            onClick={() => deleteLayout(layoutId)}
          />
        )
      ) : (
        <HashLoader className={styles.deleteLoader} size={20} color="#888" />
      )}
      <p className={styles.layoutCardName}>{reportName}</p>
      <p className={styles.layoutCardDescription}>{reportDescription}</p>
    </div>
  );
};

const ExistingLayouts: React.FC<any> = () => {
  const layouts = useSelector((state: any) => state.reportLayouts);
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useDispatch();

  async function handleDeleteLayout(layoutId: string) {
    setIsLoading(true);
    try {
      const res = await invalidateLayout(layoutId);
      if ((res as any).success) {
        dispatch(setReportLayouts((res as any).data.reports));
        dispatch(setReportsTabItems((res as any).data.reports));
        dispatch(setInventoryLayouts((res as any).data.inventories));
        dispatch(setInventoryTabItems((res as any).data.inventories));
        dispatch(setChecklistLayouts((res as any).data.checklists));
        dispatch(setChecklistTabItems((res as any).data.checklists));
        dispatch(setTrackerLayouts((res as any).data.trackers));
        dispatch(setTrackerTabItems((res as any).data.trackers));
      } else {
        console.error('Failed to delete layout');
      }
    } catch (error) {
      console.error('Error deleting layout:', error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className={styles.wrapper}>
      {Array.from(Object.values((layouts as any).reportLayouts)).length > 0 && (
        <p className={styles.subHeadline}>Reports</p>
      )}
      <div className={styles.reportContainer}>
        {Array.from(Object.values((layouts as any).reportLayouts)).map(
          (rep) => {
            return (
              <LayoutCard
                isLoading={isLoading}
                deleteLayout={handleDeleteLayout}
                layoutId={(rep as any).layoutId}
                reportDescription={(rep as any).reportDescription}
                reportName={(rep as any).reportName}
              />
            );
          }
        )}
      </div>
      {Array.from(Object.values((layouts as any).checklistLayouts)).length >
        0 && <p className={styles.subHeadline}>Checklists</p>}
      <div className={styles.reportContainer}>
        {Array.from(Object.values((layouts as any).checklistLayouts)).map(
          (rep) => {
            return (
              <LayoutCard
                reportDescription={(rep as any).reportDescription}
                reportName={(rep as any).reportName}
              />
            );
          }
        )}
      </div>
      {Array.from(Object.values((layouts as any).inventoryLayouts)).length >
        0 && <p className={styles.subHeadline}>Inventories</p>}
      <div className={styles.reportContainer}>
        {Array.from(Object.values((layouts as any).inventoryLayouts)).map(
          (rep) => {
            return (
              <LayoutCard
                reportDescription={(rep as any).reportDescription}
                reportName={(rep as any).reportName}
              />
            );
          }
        )}
      </div>
      {Array.from(Object.values((layouts as any).trackerLayouts)).length >
        0 && <p className={styles.subHeadline}>Trackers</p>}
      <div className={styles.reportContainer}>
        {Array.from(Object.values((layouts as any).trackerLayouts)).map(
          (rep) => {
            return (
              <LayoutCard
                reportDescription={(rep as any).reportDescription}
                reportName={(rep as any).reportName}
              />
            );
          }
        )}
      </div>
    </div>
  );
};

export default ExistingLayouts;
